import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import * as React from 'react';

import ErrorSnackbarProps from './interfaces/errorSnackbarProps';

const ErrorSnackbar: React.FC<ErrorSnackbarProps> = ({ open, message, handleClose }) => {
  if (message.toString().length === 0) {
    return null;
  }

  if (message.includes('UsernameExistsException')) {
    message = 'An account with this email already exists. Please sign in or use a different email.';
  }

  if (message.includes('InvalidPasswordException')) {
    message =
      'Password must be at least 12 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.';
  }

  // Failed to confirm account: InvalidParameterException: 2 validation errors detected: Value '' at 'confirmationCode' failed to satisfy constraint: Member must satisfy regular expression pattern: [\S]+; Value '' at 'confirmationCode' failed to satisfy constraint: Member must have length greater than or equal to 1
  if (message.includes('confirmationCode')) {
    message = 'Invalid confirmation code. Please try again.';
  }

  // Sign up failed: InvalidParameterException: Invalid phone number format.
  if (message.includes('Invalid phone number format')) {
    message = 'Invalid phone number format. Please enter a valid phone number.';
  }

  // Failed to confirm account: CodeMismatchException: Invalid verification code provided, please try again.
  if (message.includes('CodeMismatchException')) {
    message = 'Invalid verification code provided. Please try again.';
  }

  // Check if this is a lockout error - the authService already provides a detailed message
  const lowerMessage = message.toLowerCase();
  const isLockoutError =
    lowerMessage.includes('temporarily locked') ||
    lowerMessage.includes('too many') ||
    lowerMessage.includes('attempt limit') ||
    lowerMessage.includes('locked out');

  return (
    <Snackbar
      open={open}
      autoHideDuration={isLockoutError ? 10000 : 6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      data-testid="error-snackbar-container"
    >
      <Alert
        onClose={handleClose}
        severity={isLockoutError ? 'warning' : 'error'}
        variant="filled"
        sx={{ width: '100%', maxWidth: isLockoutError ? 450 : undefined }}
        data-testid={isLockoutError ? 'lockout-alert' : 'error-alert'}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackbar;
